import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AbstractApiGuardService } from '../abstract.api-guard.service';

@Injectable({
  providedIn: 'root',
})
export class PDFApplicationService extends AbstractApiGuardService {
  private readonly apiUrl = `${environment.apiVersionString}/loan_application_pdf`;

  getLoanApplicationHtml(
    loanApplicationId: string,
    applicantId: string,
    referenceString: string
  ): Observable<{ html: string }> {
    return this.get(`${this.apiUrl}/${loanApplicationId}/${applicantId}/${referenceString}`);
  }
}
